import { configure } from "@hylable/auth"

const clientId = process.env.VUE_APP_AUTH_WEB_CLIENT_ID
const userPoolId = process.env.VUE_APP_AUTH_USER_POOL_ID
const authBrokerDomain = process.env.VUE_APP_AUTH_BROKER_DOMAIN
const isLocalDev = window.location.hostname === "localhost"

const authConf = {
  clientId,
  userPoolId,
}

function isLtiLoginPath() {
  const currentPath = window.location.pathname
  const hash = window.location.hash

  if (currentPath === "/lti/login") {
    return true
  }
  if (hash === "#/lti/login" || hash.startsWith("#/lti/login?")) {
    return true
  }
  return false
}

if (!isLocalDev && !isLtiLoginPath()) {
  const rootUrl = window.location.origin
  authConf.authBroker = {
    domain: authBrokerDomain,
    redirectSignIn: [rootUrl],
    redirectSignOut: [rootUrl],
  }
}
configure(authConf)

import { MeteringClient } from "@hylable/metering"
export const metering = new MeteringClient({endpoint: process.env.VUE_APP_METERING_URL})

import { createRequestInstance } from "@hylable/common"
export const discussionInstance = createRequestInstance("discussion", process.env.VUE_APP_DISCUSSION_URL)
export const recorderInstance = createRequestInstance("recorder", process.env.VUE_APP_RECORDER_URL)

export const aiLibInstance = createRequestInstance("ailib", process.env.VUE_APP_AILIB_ADAPTER_URL)
export const ltiInstance = createRequestInstance("lti", process.env.VUE_APP_AUTH_LTI_URL)
export const authRequestInstance = createRequestInstance("auth", process.env.VUE_APP_AUTH_URL)
export const organizationManagerInstance = createRequestInstance("organization-manager", process.env.VUE_APP_ORG_MNG_URL)
export const reportInstance = createRequestInstance("report", process.env.VUE_APP_REPORT_URL)
export const xapiInstance = createRequestInstance("xapi", process.env.VUE_APP_XAPI_URL)
export const knowledgebaseInstance = createRequestInstance("knowledgebase", process.env.VUE_APP_KNOWLEDGEBASE_API_URL)

import { DiscussionClient } from "@hylable/discussion"
export const discussionClient = new DiscussionClient({endpoint: process.env.VUE_APP_DISCUSSION_URL})

import { RecorderClient } from "@hylable/recorder"
export const recorderClient = new RecorderClient({endpoint: process.env.VUE_APP_RECORDER_URL})
